import styled from 'styled-components'
import { ReactElement } from 'react'
import { IIconProps } from './types'

const Svg = styled.svg`
  width: '12px';
  height: '18px';
`

export const HandLuggageIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg
      className={className}
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V14C12 14.825 11.325 15.5 10.5 15.5H1.5C0.675 15.5 0 14.825 0 14V5C0 3.605 0.96 2.4425 2.25 2.105V0.5H4.5V2H7.5V0.5H9.75V2.105C11.04 2.4425 12 3.605 12 5ZM1.5 8V9.5H9V11H10.5V8H1.5Z"
        fill="#5D5C70"
      />
    </Svg>
  )
}
